
import { takeLatest, put, call } from 'redux-saga/effects';
import { HTTP_HEADERS } from '../../../../constants';
import request from '../../../../components/Utils/httpHelper';
import {
    CREATE_OVERRIDDING_RISKFACTOR,
    createOverriddingRiskFactorSuccess,
    createOverriddingRiskFactorFailure,
    FETCH_OVERIDDING_RISKFACTOR_DETAILS,
    overiddingRiskFactorDetailsSuccess,
    overiddingRiskFactorDetailsFailure,
    EDIT_OVERRIDDING_RISKFACTOR,
    editOverriddingRiskFactorSuccess,
    editOverriddingRiskFactorFailure
} from './action';
import { SCORE_DEFINATION } from '../../../../config';


export function* overiddingRiskFactorCreate(action) {
    let requestUrl = `${SCORE_DEFINATION}/overridingriskfactor/`;
    try {
        const createResult = yield call(request, requestUrl, { data: action.data, method:'POST', headers: HTTP_HEADERS });
        yield put(createOverriddingRiskFactorSuccess(createResult));
    } catch (err) {
        yield put(createOverriddingRiskFactorFailure(err))
    }
}
export function* addOveriddingRiskFactor() {
    yield takeLatest(CREATE_OVERRIDDING_RISKFACTOR, overiddingRiskFactorCreate);
}

export function* overiddingRiskFactorDetails(action) {
    let requestUrl = `${SCORE_DEFINATION}/overridingriskfactor/${action.data}`;
    try {
        const fetchResult = yield call(request, requestUrl, { data: '', method:'GET', headers: HTTP_HEADERS });
        yield put(overiddingRiskFactorDetailsSuccess(fetchResult));
    } catch (err) {
        yield put(overiddingRiskFactorDetailsFailure(err))
    }
}
export function* fetchOveriddingRiskFactor() {
    yield takeLatest(FETCH_OVERIDDING_RISKFACTOR_DETAILS, overiddingRiskFactorDetails);
}

export function* overiddingRiskFactorEdit(action) {
    let requestUrl = `${SCORE_DEFINATION}/overridingriskfactor/${action.data.id}`;
    try {
        const editResult = yield call(request, requestUrl, { data: action.data.requestBody, method:'PUT', headers: HTTP_HEADERS });
        yield put(editOverriddingRiskFactorSuccess(editResult));
    } catch (err) {
        yield put(editOverriddingRiskFactorFailure(err))
    }
}
export function* editOveriddingRiskFactor() {
    yield takeLatest(EDIT_OVERRIDDING_RISKFACTOR, overiddingRiskFactorEdit);
}